module.exports = __webpack_public_path__ + "img/logo-small-header.058a3c58.png";